import { CurrencyRateDetails } from 'further-types/lp/transaction';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { calculateLcyValue } from 'further-ui/utils';
import { round } from 'lodash';
import { ProcessedRevaluation } from '../../helpers/processRevaluationHistory';
import getLatestRevaluationsForEachHoldingClass from './getLatestRevaluationsForEachHoldingClass';

function hasLcyValuationChanged(
  rev: ProcessedRevaluation,
  baseCurrency: CurrencyCode,
  fxRate: CurrencyRateDetails | null | undefined,
): boolean {
  if (rev.currency === baseCurrency) {
    return rev.hasChange;
  }
  if (!fxRate || rev.priorValuationLcy == null) {
    return false;
  }
  const newValuationLcy = calculateLcyValue(rev.newValuation, fxRate);
  return round(newValuationLcy, 2) !== round(rev.priorValuationLcy, 2);
}

export default function filterChangedRevaluations(
  revaluationHistory: Array<ProcessedRevaluation>,
  baseCurrency: CurrencyCode,
  revaluationCurrencyRates?: Record<string, CurrencyRateDetails | undefined>,
) {
  const globalFxRate = revaluationCurrencyRates?.global ?? null;
  return getLatestRevaluationsForEachHoldingClass(revaluationHistory).filter(
    (rev) => {
      const fxRate =
        revaluationCurrencyRates?.[rev.holdingClassId] ?? globalFxRate;
      return rev.isNew && hasLcyValuationChanged(rev, baseCurrency, fxRate);
    },
  );
}
